<template>
  <div >
    <Header
        :leftArrow="true"
        :leftText="''"
        @leftClick="onClickLeft"
        :rightIcons="false"
    >
    </Header>
    <div class="c-wrapper">
      <van-form style="width: 100%; max-width: 500px" ref="chatForm">
        <van-cell-group inset>
          <van-field
              v-model="messageTitle"
              autosize
              label="タイトル:"
              :rules="[{ required: true, message: 'タイトルを入力してください' }]"
              type="text"
              maxlength="20"
              placeholder="タイトル内容を入力してください"
              show-word-limit
          />
          <van-field
              v-model="messageContent"
              rows="2"
              autosize
              label="内容:"
              :rules="[{ required: true, message: '内容を入力してください' }]"
              type="textarea"
              maxlength="100"
              placeholder="送信内容を入力してください"
              show-word-limit
          />
          <van-field name="switch" input-align="right" label="文字スクロール" label-width="50%">
            <template #input>
              <van-switch v-model="fixedStatus" @change="changeFixedStatus" size="20" active-color="#3B82C4"/>
            </template>
          </van-field>
          <van-field name="switch" input-align="right" label="文字の朗読" label-width="50%">
            <template #input>
              <van-switch v-model="readStatus" @change="changeReadText" size="20" active-color="#3B82C4"/>
            </template>
          </van-field>
          <van-field name="switch" input-align="right" label="送信予約" label-width="50%">
            <template #input>
              <van-switch v-model="yoteiStatus" size="20" active-color="#3B82C4"/>
            </template>
          </van-field>
          <van-field readonly clickable label-width="8rem" input-align="right" label="送信予約時間:"
             v-show="yoteiStatus"
             v-model="yoteiSendTime" @click="showYoteiTimeChoose = true" placeholder="日付を選択してください"
                     :rules="yoteiStatus ? [{ required: true, message: '送信予約時間を選択してください' }
                , { validator: validateFutureTime, message: '選択した時間は現在の時間より後でなければなりません' }] : [{}]">
          </van-field>
          <van-field readonly clickable label-width="8rem" input-align="right" label="表示終了期限:"
            v-model="endTime" @click="showTimeChoose = true" placeholder="日付を選択してください"
            :rules="[{ required: true, message: '表示終了時間を選択してください' },
            { validator: validateEndTime, message: '表示終了時間は送信予約時間より後でなければなりません' }]">
          </van-field>
          <van-field
              name="switch"
              input-align="right"
              label="全員に送信">
            <template #input>
              <van-switch
                  v-model="checkInfo"
                  size="20"
                  active-color="#3B82C4"
                  @change="changeSendType"
              />
            </template>
          </van-field>
          <van-field
              readonly
              clickable
              label="送信先:"
              name="type"
              v-model="chooseName"
              rows="1"
              autosize
              type="textarea"
              placeholder="選択してください"
              label-width="8rem"
              :rules="confirmPatients"
              @click="showChoose"
              v-show="chooseVisable"
              input-align="right"
          />
          <div v-if="showType" class="popup-bg">
            <div class="popup">
              <div class="btn">
                <div @click="cancel" class="cancle">キャンセル</div>
                <div @click="confirm" class="confirm">確認</div>
              </div>
              <van-checkbox-group v-model="result">
                <van-cell-group>
                  <van-cell
                      v-for="(item, index) in patientColums"
                      clickable
                      :key="index"
                      :title="item.name"
                      @click="toggle(item, index)"
                  >
                    <template #right-icon>
                      <van-checkbox
                          :name="item.patient_id"
                          shape="square"
                          ref="checkboxes"
                          @click.stop="toggle(item, index)"
                      />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </div>
          </div>
          <van-popup v-model:show="showTimeChoose" position="bottom" :style="{ height: '35%' }" >
            <van-datetime-picker
                v-model="currentDate" type="datetime" title="日付を選択してください"
                :min-date="minDate" :max-date="maxDate"
                @confirm="confirmFn" @cancel="showTimeChoose = false;"/>
          </van-popup>
          <van-popup v-model:show="showYoteiTimeChoose" position="bottom" :style="{ height: '35%' }" >
            <van-datetime-picker
                v-model="yoteiDate" type="datetime" title="日付を選択してください"
                :min-date="minDate" :max-date="maxDate"
                @confirm="confirmYoteiDate" @cancel="showYoteiTimeChoose =false;"/>
          </van-popup>
        </van-cell-group>
        <div style="margin: 50px 16px 16px 16px">
          <van-button
              round block type="primary" native-type="submit" :color="'#48b2fb'"
              @click="handleSure" id="mypage_btn">送信
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import {GetPatientChooseList} from "@/services/patient";
import {Toast} from "vant";
import "vant/es/toast/style";
import Header from "@/components/Header.vue";
import {SaveChatRecord} from "@/services/chatrecord";
import {doSend} from "@/utils/websocket";

export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY)),
      messageTitle:'',
      messageContent:'',

      showType: false,
      patientColums: [],
      activeIndexList: [],
      activeIndexListCode: [],
      chooseName: "",
      oldChooseValue: [],
      oldChooseName:[],
      result: [],

      checkInfo:false,
      chooseVisable:true,
      userInfo:null,
      fixedStatus:false,
      fixedType:0,
      readStatus:false,
      readType:0,

      confirmPatients: [
        {
          // 自定义表单校验
          validator: () => {
            if (!this.checkInfo && this.activeIndexListCode.length < 1) {
              return false;
            } else {
              return true;
            }
          },
          message: "送信先を選択してください",
          trigger: "onBlur/onChange",
        },
      ],

      minDate: new Date(),
      maxDate: new Date(new Date().getFullYear() + 5, 12, 31),
      // 表示終了時間
      currentDate: new Date(),
      showTimeChoose:false,
      endTime:'',

      // 送信予約時間
      yoteiStatus:false,
      yoteiDate: new Date(),
      showYoteiTimeChoose:false,
      yoteiSendTime:''
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.userInfo = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_KEY)
    );
    const patient_id = this.$route.query.patient_id;
    const patient_name = this.$route.query.patient_name;
    if(patient_id){
      this.result[0] = patient_id
      this.activeIndexList.push(patient_name);
      this.activeIndexListCode.push(patient_id);
      this.oldChooseValue = this.activeIndexListCode.slice();
      this.oldChooseName= this.activeIndexList.slice();
      this.chooseName = this.activeIndexList.toString();
    }
    this.initPatientList();
  },
  methods: {
    validateEndTime(value) {
      if(!this.yoteiStatus){
        return  true;
      }
      if (!value) return false;
      const endTime = new Date(value.replace(/-/g, "/"));
      const startTime = new Date(this.yoteiSendTime.replace(/-/g, "/"));
      return endTime > startTime;
    },
    validateFutureTime(value){
      if (!value) return false;
      const selectedTime = new Date(value.replace(/-/g, "/"));
      const currentTime = new Date();
      return selectedTime > currentTime;
    },
    confirmFn() {
      this.endTime = this.timeFormat(this.currentDate);
      this.showTimeChoose = false;
    },
    confirmYoteiDate(){
      this.yoteiSendTime = this.timeFormat(this.yoteiDate);
      this.showYoteiTimeChoose = false;
    },
    timeFormat(time) {
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      month = month < 10 ? ('0' + month) : month;
      let day = time.getDate();
      day = day < 10 ? ('0' + day) : day;
      let h = time.getHours();
      h = h < 10 ? ('0' + h) : h;
      let minutes = time.getMinutes();
      minutes = minutes < 10 ? ('0' + minutes) : minutes;
      return year + '-' + month + '-' + day + '  ' + h + ':' + minutes
    },
    changeSendType(checkStatus){
      this.checkInfo = checkStatus;
      if (this.checkInfo) {
        // this.clearData();
        this.chooseVisable = false;
      } else {
        this.chooseVisable = true
      }
    },
    changeFixedStatus(checkStatus){
      this.fixedStatus = checkStatus;
      if(this.fixedStatus){
        this.fixedType = 1
      }else {
        this.fixedType = 0
      }
    },
    changeReadText(checkStatus){
      this.readText = checkStatus;
      if(this.readText){
        this.readType = 1
      }else {
        this.readType = 0
      }
    },
    initPatientList() {
      GetPatientChooseList().then((res) => {
        this.patientColums = res.data.data || [];
      });
    },
    showChoose() {
      this.showType = true;
      this.result = this.activeIndexListCode
    },
    confirm() {
      this.showType = false;
      this.chooseName = this.activeIndexList.toString();
      this.oldChooseValue = this.activeIndexListCode.slice();
      this.oldChooseName= this.activeIndexList.slice();
    },
    cancel() {
      this.showType = false;
      this.activeIndexListCode =this.oldChooseValue.slice();
      this.activeIndexList = this.oldChooseName.slice();
      this.result = this.oldChooseValue.slice();
      this.chooseName = this.activeIndexList.toString();
    },
    toggle(item, index) {
      this.$refs.checkboxes[index].toggle();
      this.activeIndexList.push(item.name); // 选项名字
      this.activeIndexListCode.push(item.patient_id); // 选项code
      let arr = [];
      let arrCode = [];
      for (let i = 0; i < this.activeIndexList.length; i++) {
        if (arr.indexOf(this.activeIndexList[i]) == -1) {
          //选中的新数组里面没有相同的数据push到选中的新数组里面
          arr.push(this.activeIndexList[i]);
        } else if (arr.indexOf(this.activeIndexList[i]) > -1) {
          //选中的新数组里面有相同的数据，去掉选中的新数组里面的值,代表点击的行已被点击过，这次点击则删除选中数组里面的值
          let index = arr.indexOf(this.activeIndexList[i]);
          arr.splice(index, 1);
        }
      }
      for (let i = 0; i < this.activeIndexListCode.length; i++) {
        if (arrCode.indexOf(this.activeIndexListCode[i]) == -1) {
          //选中的新数组里面没有相同的数据push到选中的新数组里面
          arrCode.push(this.activeIndexListCode[i]);
        } else if (arrCode.indexOf(this.activeIndexListCode[i]) > -1) {
          //选中的新数组里面有相同的数据，去掉选中的新数组里面的值,代表点击的行已被点击过，这次点击则删除选中数组里面的值
          let index = arrCode.indexOf(this.activeIndexListCode[i]);
          arrCode.splice(index, 1);
        }
      }
      this.activeIndexListCode = arrCode;
      this.activeIndexList = arr;
    },
    onClickLeft() {
      history.back();
    },
    clearData(){
      this.result = []
      this.activeIndexList = []
      this.activeIndexListCode = []
      this.oldChooseValue = []
      this.oldChooseName= []
      this.chooseName = ''
    },
    handleSure() {
      this.$refs.chatForm.validate().then(() => {
        let detail = null
        if(this.checkInfo) {
          detail = {
            chat_type:'toAllPatients',
            send_user:this.userInfo.login_account_id,
            send_name:this.userInfo.name,
            title:this.messageTitle.trim(),
            content:this.messageContent.trim(),
            fixed_type:this.fixedType,
            show_end_time:this.endTime+':59',
            read_type:this.readType,
            yotei_send_time:this.yoteiStatus && this.yoteiSendTime?this.yoteiSendTime+':00':null,
          }
        }else {
          detail = {
            chat_type:'toOnePatient',
            send_user:this.userInfo.login_account_id,
            send_name:this.userInfo.name,
            title:this.messageTitle.trim(),
            content:this.messageContent.trim(),
            to_users:this.activeIndexListCode,
            fixed_type:this.fixedType,
            show_end_time:this.endTime+':59',
            read_type:this.readType,
            yotei_send_time:this.yoteiStatus && this.yoteiSendTime?this.yoteiSendTime+':00':null,
          }
        }
        if(this.checkInfo){
          this.clearData();
        }
        SaveChatRecord({detail:detail}).then((res)=>{
          this.messageTitle = "";
          this.messageContent = "";
          Toast("送信成功");
          this.clearData();
          this.chooseVisable = false;
          this.checkInfo = false;
          this.fixedStatus = false;
          this.fixedType = 0;
          this.chooseVisable = true;
          this.minDate = new Date();
          this.endTime =  '';
          this.readStatus = false;
          this.read_type = 0;
          this.yoteiStatus = false;
          this.yoteiSendTime = '';
          if(res.data.data) {
            doSend(JSON.stringify(res.data.data));
          }
        });
      }).catch(() => {
        Toast.fail("追加に失敗しました");
      });
    },
  },
};
</script>

<style scoped>
#mypage_btn {
  width: 100%;
  height: 54px;
  background: #AACBE7;
  border-radius: 8px;
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 54px;
  text-align: center;
  margin-top: auto;
}
#mypage_btn.possible {
  background: #3B82C4;
  pointer-events: auto;
}
.c-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.popup-bg {
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
}
.btn {
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 999;
  background-color: white;
}
.cancle {
  padding: 15px 0px 15px 18px;
  font-size: 18px;
  font-weight: bold;
}
.confirm {
  padding: 15px 18px 15px 0px;
  font-size: 18px;
  font-weight: bold;
}
.popup {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 400px;
  overflow: auto;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: #fff;
}
.item {
  padding: 0 15px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f7f8f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.selected {
  width: 16px;
  height: 16px;
  background-size: 16px auto;
}
</style>
